export type HydraSearchItem = {
    "@type": string;
    variable: string;
    property: string;
    required: boolean;
};

export type HydraSearch = {
    "hydra:mapping": HydraSearchItem[];
};

export type SearchValue = string | string[] | Record<string, string[]>;
export const SEARCH_TAGS = "tags" as const;

export type AppSearch = Record<
    string,
    {
        value: SearchValue;
        isSortable?: boolean;
    }
>;

export const hydraSearchToAppSearch = (hydraSearch: HydraSearch): AppSearch => {
    const mappings = hydraSearch["hydra:mapping"];

    const filterMappings = mappings.filter((m) => m.property && !m.variable.startsWith("order["));

    const complexFilterProps = new Set<string>();
    for (const mapping of filterMappings) {
        if (mapping.variable.includes("[") && !mapping.variable.endsWith("[]")) {
            complexFilterProps.add(mapping.property);
        }
    }

    const appSearch: AppSearch = {};
    for (const mapping of filterMappings) {
        if (complexFilterProps.has(mapping.property)) {
            continue;
        }

        if (mapping.variable === `${mapping.property}[]`) {
            appSearch[mapping.property] = { value: [] };
        } else if (mapping.variable === mapping.property) {
            if (!appSearch[mapping.property]) {
                appSearch[mapping.property] = { value: "" };
            }
        }
    }

    const hasTags = filterMappings.find((i) => i.property === SEARCH_TAGS);
    if (hasTags !== undefined) {
        appSearch[SEARCH_TAGS] = { value: {} };
    }

    return appSearch;
};
